var _rect, _line, _rect2, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDesktop(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 59,
    height: 49,
    viewBox: "0 0 59 49",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.47508,
    y: 0.93831,
    width: 56.0498,
    height: 38.2938,
    rx: 2.48607,
    stroke: "#EFB729",
    strokeWidth: 1.65738
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 0.646393,
    y1: 32.1298,
    x2: 58.3536,
    y2: 32.1298,
    stroke: "#EFB729",
    strokeWidth: 1.65738
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 27.2798,
    y: 34.7341,
    width: 4.43902,
    height: 1.77561,
    rx: 0.887804,
    fill: "#EFB729"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.842 40.0613L21.0664 47.6076",
    stroke: "#EFB729",
    strokeWidth: 1.65738,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1586 40.0613L37.9342 47.6076",
    stroke: "#EFB729",
    strokeWidth: 1.65738,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4025 48.0515L41.4854 48.0515",
    stroke: "#EFB729",
    strokeWidth: 1.65738,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesktop);
export default __webpack_public_path__ + "static/media/desktop.17865d20dfe1b99b5de3b911d9c024b1.svg";
export { ForwardRef as ReactComponent };